// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"D_PH_TheComp__YZyJ_"};